export default __webpack_public_path__ + "static/media/photogallery-06.5c0e86ac.webp";